// Dependencies
import moment from "moment";
import { formatMoney } from "accounting-js";
import { deburr } from "lodash";
import React from "react";
import Icon from "../components/Icon";

// Limpiamos un string de espacios por delante y por detras
export const cleanString = (string) => string.trim();

// Formateamos una fecha
export const formatDate = (date, format = "DD/MM/YYYY") => {
  const parsedDate = new Date(date);
  const formatDate = moment.utc(parsedDate).format(format);
  return formatDate;
};

// Formateamos un número con decimales y el simbolo de la moneda
export const toCurrency = (number, decimals = 4, withEuro = true) => {
  const options = {
    symbol: "",
    decimal: ",",
    thousand: ".",
    precision: decimals,
  };

  if (!number || isNaN(number)) {
    throw new Error("Solo se permiten números");
  } else {
    return `${formatMoney(number, options)}${withEuro ? " €" : ""}`;
  }
};

// Limpiamos una cadena de texto de acentos
const toSimpleString = (data) => deburr(data.toString().toLowerCase().trim());
// Filtrar un array por una cadena de texto
export const filterArrayByString = (array, searchValue, fields) => {
  return array.filter((item) => {
    const objectKeys = Object.keys(item);
    const fieldsToFiltered =
      fields && fields.length
        ? objectKeys.filter((i) => fields.includes(i))
        : objectKeys;
    return fieldsToFiltered.some((element) => {
      const el = item[element];
      if (el) {
        return toSimpleString(el).indexOf(toSimpleString(searchValue)) !== -1;
      }
      return false;
    });
  });
};

// Obtenemos un registro único por el campo indicado de un array de objetos
export const filterByUnique = (array, key) =>
  array.reduce(
    (acc, cur) => (!acc.find((i) => i[key] === cur[key]) ? [...acc, cur] : acc),
    []
  );

// Descargamos un pdf
export const downloadPDF = (data, filename) => {
  const blob = new Blob([data], { type: "application/pdf" });
  const pdfURL = window.URL.createObjectURL(blob);
  let tempLink;
  tempLink = document.createElement("a");
  tempLink.href = pdfURL;
  tempLink.setAttribute("download", filename);
  return tempLink.click();
};

// Descargamos un xlsx
export const downloadXLSX = (data, filename) => {
  const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const fileURL = window.URL.createObjectURL(blob);
  let tempLink;
  tempLink = document.createElement("a");
  tempLink.href = fileURL;
  tempLink.setAttribute("download", filename);
  return tempLink.click();
};

// Agrupamos y ordenamos los artículos por familias
// prettier-ignore
export const articulosPorFamilias = array =>
  array
    .sort((a, b) => a["codFamilia_A3"].localeCompare(b["codFamilia_A3"]))
    .reduce((acc, cur, _, self) => 
      acc.find(t => t["codFamilia"] === cur["codFamilia_A3"].trim()) ? acc : [
          ...acc,
          {
            key: `fam${cur["codFamilia_A3"].trim()}`,
            title: cur["descFamilia"],
            codFamilia: cur["codFamilia_A3"].trim(),
            children: self
              .filter(t => t["codFamilia_A3"] === cur["codFamilia_A3"])
              .sort((a, b) => a["descArticulo"].localeCompare(b["descArticulo"]))
              .map(t => ({ title: t["descArticulo"], key: t["codArticulo_A3"].trim(), codArticulo: t["codArticulo_A3"].trim()}))
          }
      ], 
    []);

// String to Boolean
export const strToBool = (value) =>
  value && typeof value === "string" && value === "T";

// Render boolean icon
export const renderBoolIcon = (t) => {
  const props = {
    color: t === "T" || t === true ? "#2E7D32" : "#EA1717",
    type: t === "T" || t === true ? "check-circle" : "close-circle",
  };
  return <Icon {...props} />;
};
